import React from 'react'
import styled from '@emotion/styled'
import { COLORS, PAGE_BREAKPOINTS } from 'parameters/index'
import { stripHTML } from 'lib'
import Link from 'next/link'
import ContentfulImage from 'experiences/shared/ContentfulImage'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { getAbstract } from 'components/vendor/Contentful/richText/utils'

interface PartnerModel {
	partner: Partner
	hideDescription?: boolean
}

export const PartnerCard = ({ partner, hideDescription }: PartnerModel): JSX.Element => {
	const sliceDescription = (value: string): string => value.split(' ').slice(0, 10).join(' ') + '...'

	const getPartnerText = (): string => {
		if (partner.description) {
			return sliceDescription(stripHTML(getAbstract(partner.description)))
		}
		return ''
	}

	const logo = partner?.logo

	return (
		<Link passHref href={`/learn/partners/${partner.slug}`}>
			<PartnerItemWrapper>
				<PartnerImage>
					{logo && (
						<ContentfulImage
							asset={logo}
							width={132}
							height={72}
							layout={'intrinsic'}
							objectFit="contain"
							placeholder={true}
						/>
					)}
				</PartnerImage>
				{!hideDescription && <PartnerText>{getPartnerText()}</PartnerText>}
			</PartnerItemWrapper>
		</Link>
	)
}

export const PartnerItemWrapper = styled.div`
	display: flex;
	padding: 24px;
	border-radius: 8px;
	box-shadow: 0 0 20px 0 rgba(69, 69, 69, 0.16);
	background-color: ${COLORS.WHITE};
	align-items: center;
	height: 120px;
	cursor: pointer;
	justify-content: center;

	@media only screen and (${PAGE_BREAKPOINTS.DESKTOP_MEDIUM}) {
		flex-direction: column;
		justify-content: center;
	}

	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 282px;
	}
`

const PartnerImage = styled.div<{ hideDescription?: boolean }>`
	align-items: center;
	justify-content: ${({ hideDescription }): string => (hideDescription ? 'flex-start' : 'center')};

	@media only screen and (${PAGE_BREAKPOINTS.DESKTOP_MEDIUM}) {
		margin-right: 0;
	}
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_PORTRAIT}) {
		width: 70%;
	}
`

const PartnerText = styled.p`
	@media only screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		text-align: center;
	}
`
